import React from 'react';
import { ToggleSwitch } from '@shoflo-rundown/polymer.legacy';

export const extraOptionsFields = [
  'displayTeamTitle',
  'displayTeamLogo',
  'displayEventTitle',
  'displayEventLogo',
  'displayShowTitle',
  'grayscale',
];
export const extraOptionsFieldTitles = [
  'Team name',
  'Team logo',
  'Event name',
  'Event logo',
  'Show name',
  'Print in grayscale',
];

export default React.createClass({
  displayName: 'PDFExportExtraOptions',

  render() {
    const { options, onToggle } = this.props;

    const toggleNodes = extraOptionsFields.map((field, i) => {
      const fieldValue = options.get(field);

      return (
        <div className="pdf-options-toggle-option">
          <ToggleSwitch
            on={options.get(field)}
            alt={extraOptionsFieldTitles[i]}
            onClick={() => {
              onToggle(field, fieldValue);
            }}
          />
          &nbsp;&nbsp;{extraOptionsFieldTitles[i]}
        </div>
      );
    });

    return <div>{toggleNodes}</div>;
  },
});
